import React from "react";
import { Trans } from "app/utils";

import { OrganizationAIUsage } from "./MonitorAIUsageTypes";

interface AIContextRowProps {
  organization: OrganizationAIUsage;
}

const OrganizationAIUsageRow = ({ organization: { name, tokenUsage } }: AIContextRowProps) => (
  <tr>
    <td>
      <Trans>{name}</Trans>
    </td>
    <td>
      <Trans>{tokenUsage}</Trans>
    </td>
  </tr>
);

export default OrganizationAIUsageRow;
